/* eslint-disable complexity */
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import Box from 'carbon-react/lib/components/box';
import { Tab, TabList, TabPanel, Tabs } from 'carbon-react/lib/components/tabs/__next__';

import { Forecast } from '@futrli-sdk/predict';
import { ConsolidatedForecastListItem } from '@futrli-sdk/consolidations';

import * as styles from './forecasting-navigation-tabs.scss';
import { PREDICTIONS_SUB_PAGES_IDS } from './const';
import { PredictionsExplanation } from './prediction-explanation';
import { useForecastingPages } from './use-forecasting-pages';
import { getSelectedTabId } from './helpers';

interface Props {
  showInvoices?: boolean;
  topOffset: number;
  isOnboardingScenarioRoute: boolean;
  isOnboardingBudgetRoute: boolean;
  disabled?: boolean;
  handleOnboardingTabClick: (route: string) => void;
  showPredictionsExplanation?: boolean;
  handlePredictionExplanationsToggle?: () => void;
  forecast?: Forecast | ConsolidatedForecastListItem | null;
  isConsolidation?: boolean;
}
export const OnboardingNavigationTabs = ({
  showInvoices,
  topOffset,
  isOnboardingBudgetRoute,
  isOnboardingScenarioRoute,
  disabled,
  handleOnboardingTabClick,
  showPredictionsExplanation,
  handlePredictionExplanationsToggle,
  forecast,
  isConsolidation
}: Props) => {
  const { pathname } = useLocation();
  const intl = useIntl();

  const forecastingPages = useForecastingPages();

  const handleCarbonTabChange = useCallback(
    (tabId: string) => {
      handleOnboardingTabClick(tabId);
    },
    [handleOnboardingTabClick]
  );

  const visiblePages = forecastingPages.filter(page => {
    if (
      !showInvoices &&
      page.id === PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_INVOICES &&
      (isOnboardingBudgetRoute || isOnboardingScenarioRoute)
    ) {
      return false;
    }
    if (page.id === PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_ASSETS && isOnboardingBudgetRoute) {
      return false;
    }
    if (page.id === PREDICTIONS_SUB_PAGES_IDS.PREDICTIONS_LIABILITIES && isOnboardingBudgetRoute) {
      return false;
    }
    if (page.id === PREDICTIONS_SUB_PAGES_IDS.PREDICTION_BALANCE_SHEET && isOnboardingBudgetRoute) {
      return false;
    }
    if (page.id === PREDICTIONS_SUB_PAGES_IDS.PREDICTION_CASH_FLOW && isOnboardingBudgetRoute) {
      return false;
    }
    return true;
  });

  return (
    <Box
      className={classNames(styles.carbonContainer, styles.carbonContainerOnboarding, {
        [styles.carbonTabsDisabled]: disabled
      })}
      top={topOffset}
    >
      <Tabs orientation="horizontal" selectedTabId={getSelectedTabId(pathname, forecastingPages)}>
        <TabList
          ariaLabel={intl.formatMessage({
            id: 'predict.predictions.tabs.aria_label',
            defaultMessage: 'Predictions'
          })}
          onTabChange={handleCarbonTabChange}
        >
          {visiblePages.map(page => (
            <Tab key={page.id} id={page.route} controls={`${page.route}-panel`} label={page.linkComponent} />
          ))}
        </TabList>
        {visiblePages.map(page => (
          <TabPanel key={page.id} id={`${page.route}-panel`} tabId={page.route} />
        ))}
      </Tabs>
      <div className={styles.carbonPredictionExplanationContainer} style={{ height: 'auto' }}>
        <PredictionsExplanation
          showPredictionsExplanation={showPredictionsExplanation}
          togglePredictionsExplanation={handlePredictionExplanationsToggle}
          forecast={forecast}
          isConsolidation={isConsolidation}
        />
      </div>
    </Box>
  );
};
